import {
  IconAffiliate,
  IconApiApp,
  IconBuildingCommunity,
  IconFileEuro,
  IconLockCheck,
  IconTools,
  IconUser,
  IconUsersGroup,
} from "@tabler/icons-react";
import { Button, Paper, Stack, ThemeIcon, Tooltip } from "@mantine/core";
import { Link, useMatches } from "react-router-dom";
import { useListStore } from "../../../stores/ListStore";
import ListingHandle from "../lists/ListingWithContent/ListingHandle";
import { getPermission } from "../../../functions/utilFunctions";
import { useLanguage } from "../../../stores/LanguageStore";
import { useSessionStore } from "../../../stores/UserStore";

const LeftLinks = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const matches = useMatches();

  const minimized = useListStore((s) => s.modelMinimized);
  const setMinimized = useListStore((s) => s.setModelMinimized);

  const elements = {
    account: {
      color: "primary.4",
      items: [
        {
          label: lang.settings.links.profile,
          link: "/settings/profile",
          icon: <IconUser />,
        },
        {
          label: lang.settings.links.org,
          link: "/settings/organizations",
          icon: <IconBuildingCommunity />,
        },
        {
          label: lang.settings.links.teams,
          link: "/settings/teams",
          icon: <IconUsersGroup />,
        },
      ],
    },
    admin: {
      color: "#ff9164",
      items: [
        {
          label: lang.settings.links.permissions,
          link: "/settings/permissions",
          icon: <IconLockCheck />,
        },
        // {
        //   label: "Interface",
        //   link: "/settings/interface",
        //   icon: <IconPalette />,
        // },
        {
          label: lang.settings.links.toolbox,
          link: "/settings/tools",
          icon: <IconTools />,
        },
      ],
    },
    external: {
      color: "#78bf7c",
      items: [
        {
          label: lang.settings.links.integrations,
          link: "/settings/integrations",
          icon: <IconApiApp />,
        },
        {
          label: lang.settings.links.referrals,
          link: "/settings/my-network",
          icon: <IconAffiliate />,
        },
      ],
    },
    billing: {
      color: "purple",
      items: [
        {
          label: lang.settings.links.billing,
          link:
            reseller?.name === "Magileads"
              ? "/settings/subscription"
              : reseller?.pricing_url,
          target: reseller?.name !== "Magileads" ? "_blank" : undefined,
          icon: <IconFileEuro />,
          permission: "displayPricing",
        },
      ],
    },
  };

  const handleClick = ({ isRight }) => {
    setMinimized(!minimized);
  };

  return (
    <Paper
      component={Stack}
      w={minimized ? 75 : 250}
      py={0}
      gap={"md"}
      shadow="lg"
      pos={"sticky"}
      top={72}
      ml={32}
      radius={0}
      style={{
        transition: "all ease .3s",
        borderRadius: 12,
      }}
      pb={16}
      mb={16}
      justify="center"
    >
      <Stack
        gap={0}
        py={8}
        style={{
          overflow: "hidden",
        }}
        px={minimized ? "sm" : "lg"}
      >
        {minimized
          ? Object.keys(elements).map((key) => {
              let group = elements[key];

              return (
                <Stack
                  key={key}
                  gap={"sm"}
                  style={{
                    borderBottom:
                      key === "billing" ? "0" : "1px solid #00000012",
                  }}
                  pb={key === "billing" ? 0 : 8}
                  pt={8}
                >
                  {group.items.map((item) => {
                    let active = matches?.find((x) =>
                      x.pathname.includes(`${item.link}`)
                    );

                    if (item?.permission && !getPermission(item?.permission)) {
                      return;
                    }

                    return (
                      <Tooltip
                        label={item.label}
                        position="right"
                        key={item.link}
                      >
                        <Button
                          component={Link}
                          to={item.link}
                          key={item.link}
                          target={item?.target}
                          color={group.color}
                          radius={"md"}
                          h={54}
                          className="no-shadow"
                          leftSection={
                            <ThemeIcon
                              variant="filled"
                              size={"lg"}
                              color={group.color}
                              radius={"md"}
                            >
                              {item.icon}
                            </ThemeIcon>
                          }
                          size="md"
                          variant={active ? "filled" : "subtle"}
                          justify="start"
                          pl={8}
                          onClick={() =>
                            useListStore.getState().setModelMinimized(true)
                          }
                        >
                          {item.label}
                        </Button>
                      </Tooltip>
                    );
                  })}
                </Stack>
              );
            })
          : Object.keys(elements).map((key) => {
              let group = elements[key];

              return (
                <Stack
                  key={key}
                  gap={"sm"}
                  style={{
                    borderBottom:
                      key === "billing" ? "0" : "1px solid #00000012",
                  }}
                  pb={key === "billing" ? 0 : 8}
                  pt={8}
                >
                  {group.items.map((item) => {
                    let active = matches?.find((x) =>
                      x.pathname.includes(`${item.link}`)
                    );

                    if (item?.permission && !getPermission(item?.permission)) {
                      return;
                    }

                    return (
                      <Button
                        component={Link}
                        to={item.link}
                        key={item.link}
                        color={group.color}
                        target={item?.target}
                        radius={"md"}
                        h={54}
                        className="no-shadow"
                        leftSection={
                          <ThemeIcon
                            variant="filled"
                            size={"lg"}
                            color={group.color}
                            radius={"md"}
                          >
                            {item.icon}
                          </ThemeIcon>
                        }
                        size="md"
                        variant={active ? "filled" : "subtle"}
                        justify="start"
                        pl={8}
                        onClick={() =>
                          useListStore.getState().setModelMinimized(true)
                        }
                      >
                        {item.label}
                      </Button>
                    );
                  })}
                </Stack>
              );
            })}
      </Stack>

      <ListingHandle
        isMinimized={minimized}
        hidden={minimized}
        onClick={handleClick}
        bg="none"
      />
    </Paper>
  );
};

export default LeftLinks;
